// Custom animation initialization (replacing AOS)
export const initAOS = () => {
  // Simple function to show all elements immediately without requiring scroll
  const showAllElementsImmediately = () => {
    const elements = document.querySelectorAll('[data-aos], .animate-on-scroll, .animate-text, .animate-card');
    elements.forEach(element => {
      // Add 'animated' class for our custom animations
      element.classList.add('animated');
      
      // Also handle any potential AOS elements
      if (element.hasAttribute('data-aos')) {
        element.classList.add('aos-animate');
      }
    });
  };

  // Execute immediately
  showAllElementsImmediately();
  
  // Execute again after a short delay to ensure DOM is fully ready
  setTimeout(showAllElementsImmediately, 100);
  
  // Execute once more after page load is complete
  window.addEventListener('load', showAllElementsImmediately);
  
  // Add a mutation observer to handle elements added dynamically
  const observer = new MutationObserver((mutations) => {
    // Check if any elements were added
    let needsUpdate = false;
    
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        needsUpdate = true;
      }
    });
    
    if (needsUpdate) {
      showAllElementsImmediately();
    }
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Clean up function
  return () => {
    observer.disconnect();
    window.removeEventListener('load', showAllElementsImmediately);
  };
};
